module.exports = __webpack_public_path__ + "static/media/iconfinder_twitter_313075.35f6a159.svg";